import { FormattedMessage } from 'react-intl';
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons/faCheckCircle';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Text, TextType } from 'ui-components/components/text';
import { FlexColumn, Gap } from 'ui-components/components/flex';

import { messages } from '../../messages';
import style from '../../app-store-install-page.module.less';

type InstallSuccessCardProps = {
  appName: string;
  version: number;
};

export const InstallSuccessCard = ({ appName, version }: InstallSuccessCardProps) => (
  <div className={style.card}>
    <FlexColumn className={style.centerItems} gap={Gap.Space16}>
      <FontAwesomeIcon className={style.successIcon} icon={faCheckCircle} />
      <Text textType={TextType.H2} value={<FormattedMessage {...messages.installedTitle} values={{ appName }} />} />
      <Text
        className={style.dimText}
        textType={TextType.Description}
        value={<FormattedMessage {...messages.installedDescription} values={{ version }} />}
      />
    </FlexColumn>
  </div>
);
